import React from "react";
import { FormattedMessage } from "react-intl";

import {
  RoamingDeviceNameCard,
  RoamingDeviceNameMobileCard,
} from "../../../../spson/roamingTables/RoamingDeviceNameCard";
import { ProtectionStatus } from "../../../../spson/roamingTables/ProtectionStatus";
import { timeSort, showValue } from "../../../../../components/table/helpers";
import { ClickAbsorber } from "../../../../../components/clickAbsorber/ClickAbsorber";
import { ProfileRoamingDevicesDropdownActions } from "./components";
import { ellipsifyUUID } from "../../../../../helpers/devices.helpers";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        isExpanded,
        original: { name },
      },
    }) => <RoamingDeviceNameCard isExpanded={isExpanded} name={name} />,
  },
  {
    Header: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
    sortable: true,
    cellClassName: "table__cell--left",
    headerClassName: "table__cell--left",
    Cell: ({ row }) => (
      <ProtectionStatus status={row.original.protectionStatus} />
    ),
  },
  {
    Header: <FormattedMessage id={"last_seen_devices_table_header"} />,
    accessor: "lastSeen",
    sortType: timeSort,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { lastSeen },
      },
    }) => <div>{showValue(lastSeen)}</div>,
  },
  {
    Header: <FormattedMessage id={"actions"} />,
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { identifier, fullName, name, logicalDeviceId },
      },
    }) => (
      <ClickAbsorber>
        <ProfileRoamingDevicesDropdownActions
          identifier={identifier}
          fullName={fullName}
          name={name}
          logicalDeviceId={logicalDeviceId}
        />
      </ClickAbsorber>
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    cellClassName: "table__cell--overflow",
    Cell: ({
      row: {
        isExpanded,
        original: {
          name,
          protectionStatus,
          lastSeen,
          identifier,
          logicalDeviceId,
        },
      },
    }) => (
      <RoamingDeviceNameMobileCard
        isExpanded={isExpanded}
        name={name}
        lastSeen={lastSeen}
        protectionStatus={protectionStatus}
        aside={
          <ProfileRoamingDevicesDropdownActions
            identifier={identifier}
            fullName={name || ellipsifyUUID(identifier)}
            name={name}
            logicalDeviceId={logicalDeviceId}
          />
        }
      />
    ),
  },
  {
    SortingLabel: <FormattedMessage id={"protection_status"} />,
    accessor: "protectionStatus",
  },
  {
    accessor: "lastSeen",
    sortType: timeSort,
    SortingLabel: <FormattedMessage id={"last_seen_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = [
  "appStatus",
  "fullName",
  "identifier",
  "lastSeen",
  "model",
  "name",
  "os",
  "softwareVersion",
];

export const INITIAL_SORT = [{ id: "lastSeen", desc: true }];
